const statuses = [
    {'value': 'in_active', 'label': 'Inactive', 'variation': 'subdued'},
    // {'value': 'error', 'label': 'Error', 'variation': 'negative'},
    {'value': 'active', 'label': 'Active', 'variation': 'positive'},
]

export default statuses
